import { Phone } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal, SectionHeading, GoldButton } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { IMAGES, SERVICES, PHONE, PHONE_LINK } from "@/data/site";

const Services = () => (
  <div data-testid="services-page">
    <PageHero
      testId="services-hero"
      kicker="Our Services"
      titleLines={["Everything after", "the impact. Handled."]}
      description="Seven specialist services delivered as one seamless, end-to-end experience — coordinated by your dedicated Sage Auto Group specialist."
      image={IMAGES.interior}
    />

    <section className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-36" data-testid="services-list">
      <div className="space-y-0 border-t border-white/10">
        {SERVICES.map((service, i) => {
          const Icon = service.icon;
          return (
            <Reveal key={service.title} delay={0.03 * i}>
              <div
                data-testid={`services-item-${service.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group grid grid-cols-1 gap-6 border-b border-white/10 py-12 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-[100px_64px_1fr] md:items-start md:gap-10 md:px-6"
              >
                <span className="font-mono text-sm text-gold/80">0{i + 1}</span>
                <Icon className="h-8 w-8 text-gold" strokeWidth={1.25} />
                <div>
                  <h2 className="font-serif text-3xl text-white transition-colors duration-300 group-hover:text-gold md:text-4xl">
                    {service.title}
                  </h2>
                  <p className="mt-4 max-w-3xl text-base leading-relaxed text-zinc-400">{service.description}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>

    <section className="bg-carbon py-28 md:py-36" data-testid="services-cta">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 md:px-10 lg:grid-cols-2">
        <div>
          <SectionHeading
            kicker="Get Started"
            title={<>Not sure what you need? <span className="italic text-gold-gradient">Just call.</span></>}
            description={`One conversation with our team is enough to set everything in motion. Call ${PHONE} or send a request and we'll call you back.`}
          />
          <Reveal delay={0.15}>
            <div className="mt-10">
              <GoldButton href={PHONE_LINK} testId="services-call-button">
                <Phone className="h-4 w-4" strokeWidth={2} /> Call {PHONE}
              </GoldButton>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <EnquiryForm />
        </Reveal>
      </div>
    </section>
  </div>
);

export default Services;
